module.exports = __webpack_public_path__ + "static/media/icon_microphone_w.e954fe05.svg";